import React, { useState, useCallback, useMemo } from "react";
import { Button, Col, Input, Row } from "antd";
import { AutoResizeTextArea } from "../../AutoResizeTextArea";
import styles from "./style.scss";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";
import { selectAdData } from "../../../routes/AdForm/adForm.ducks";

import { CategoryName, ModuleName } from "../../../models";

import { api, checkEmptyObject, getWindowWidth, isSearchMobile, notification } from "../../../services";
import { mapCategoryToEn, mapModuleToEn } from "../../../routes/LanguageMapper";

export interface SuggestedAiTitleProps {
  title: string;
  placeholder: string;
  isDisabled: boolean;
  size: "large" | "small" | "default";
  field: string;
  value: any;
  onChange: (value: any) => void;
}

const SuggestedAiTitle = (props: SuggestedAiTitleProps) => {
  const {
    title,
    placeholder,
    isDisabled,
    size,
    field,
    value,
    onChange
  } = props;

  const selectedData = useSelector(selectAdData);

  const [isGenerated, setIsGenerated] = useState(false);
  const [suggestedTitleList, setSuggestedTitleList] = useState([]);
  const [suggestedTitle, setSuggestedTitle] = useState(value && value[field] ? value[field] : "");
  const [disabled, setDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isMobile = isSearchMobile(getWindowWidth());

  const eligibleForSuggestedTitle = useMemo(() => {
    if (!selectedData || !selectedData.module || !selectedData.category) return false;
    
    return (
      mapModuleToEn(selectedData.module) === ModuleName.vehicles &&
      mapCategoryToEn(selectedData.category, mapModuleToEn(selectedData.module)) === CategoryName.car &&
      selectedData.makeId &&
      selectedData.modelId &&
      selectedData.makeYear &&
      selectedData.fuel
    );
  }, [selectedData]);

  const handleChange = element => {
    const { value } = element.target;

    if (value.length > 100) {
      notification.show("Naslov ne smije sadržavati više od 100 znakova!");
      return;
    }

    if (disabled) {
      setDisabled(false);
    }

    setSuggestedTitle(value);
  };

  const handleFetchSuggestedTitleList = useCallback(async () => {
    setIsLoading(true);
    setSuggestedTitleList([]);

    ReactGA.event({
      category: "AI alat",
      action: "Click",
      label: "Generiraj naslov oglasa"
    });

    try {
      const res = await api.AI.suggestedTitle({
        ...selectedData,
        module: mapModuleToEn(selectedData.module),
        category: mapCategoryToEn(selectedData.category, mapModuleToEn(selectedData.module)),
      });
      if (!checkEmptyObject(res) && res.message) return;
      setSuggestedTitleList(JSON.parse(res.message));
      setIsLoading(false);

    } catch (e) {
      console.error(e);
      setIsLoading(false);
      setIsGenerated(true);
    }

  }, [selectedData]);

  const handleChangeTitle = () => {
    setSuggestedTitleList([]);
    onChange({ [field]: suggestedTitle });
    setDisabled(true);
    notification.show("Uspješno ste primijenili sugerirani naslov");
  };

  return eligibleForSuggestedTitle ? (<Row>
    <Col>
      <span className={styles.title}>
        {title}
      </span>
    </Col>
    <Col span={isMobile ? 24 : 14}>
      <Row>
        <Col>
          {!isMobile ? (
            <Input
              size={size}
              value={suggestedTitle}
              placeholder={placeholder}
              onChange={handleChange}
              disabled={disabled || isDisabled || !isGenerated}
              className={styles.input}
              suffix={`${suggestedTitle.length} / 100`}
              style={{ resize: "none", height: "50px !important" }}

            />
          ) : (
            <React.Fragment>
              <AutoResizeTextArea
                value={suggestedTitle}
                placeholder={placeholder}
                onChange={handleChange}
                disabled={disabled || isDisabled || !isGenerated}
                autoSize={{ minRows: 1, maxRows: 3 }}
                className={styles.mobileInput}
              />
              <span className={styles.mobileSpan}>
                {`${suggestedTitle.length} / 100`}
              </span>
            </React.Fragment>
          )}
        </Col>
      </Row>
    </Col>
    <Col span={isMobile ? 24 : 10}>
      <Button
        type="primary"
        onClick={suggestedTitle && isGenerated ? handleChangeTitle : handleFetchSuggestedTitleList}
        className={styles.button}
        disabled={disabled || isDisabled}
        loading={isLoading}
      >
        {suggestedTitle && isGenerated ? "Primjeni" : "Predloži naslov pomoću AI"}
      </Button>
    </Col>

    {suggestedTitleList.length > 0 ? (
      <Col span={24} className={styles.suggestedTitleList}>
        <div className={styles.suggestionWrapper}>
          <p className={styles.subtitle}>
            {"Odaberi naslov oglasa:"}
          </p>

          <div className={styles.suggestionList}>
            {suggestedTitleList.map((title, index) => {
              return <div
                className={`${styles.suggestion} ${styles.suggestionFilled}`}
                key={index}
                onClick={() => {
                  onChange({ aiTitle: title });
                  setSuggestedTitle(title);
                  setIsGenerated(true);
                }}
              ><div>
                  {title}
                </div>
              </div>;
            })}
          </div>
        </div>
      </Col>
    ) : null
    }
  </Row >) : null;
};

export default SuggestedAiTitle;



// WEBPACK FOOTER //
// ./src/components/FormControls/SuggestedAiTitle/index.tsx